<mat-toolbar color="accent">Add Account Credit</mat-toolbar>

<form [formGroup]="accountCreditForm" (ngSubmit)="submit()">
  <mat-dialog-content>
    <div fxFlex fxLayout="column">
      <mat-form-field fxFlex>
        <mat-label>Description</mat-label>
        <input matInput formControlName="description" />
      </mat-form-field>

      <pr-practice-selector
        *ngIf="organisation.hasMultiplePractices$ | async"
        [brands]="[data.brand]"
        [practice]="selectedPractice$ | async"
        (practiceSelected)="selectedPractice$.next($event)"
      />

      <div formGroupName="reservedFor">
        <pr-staff-selector
          formControlName="practitioner"
          label="Reserve for Practitioner"
          [practice]="selectedPractice$ | async"
          [permissions]="permissions"
        />

        <mat-form-field class="!flex grow" floatLabel="always">
          <mat-label>Treatment Category</mat-label>
          <mat-select
            formControlName="treatmentCategory"
            placeholder="None"
            [compareWith]="treatmentCategoryBloc.compareFn"
          >
            <mat-select-trigger>
              @if (
                treatmentCategoryBloc.selected$ | async;
                as treatmentCategory
              ) {
                {{ treatmentCategory?.name }}
                <div
                  class="inline-block h-3 w-3 rounded-full"
                  [style.backgroundColor]="treatmentCategory?.colour.value"
                ></div>
              }
            </mat-select-trigger>
            <mat-option>None</mat-option>
            @for (
              treatmentCategory of treatmentCategoryBloc.options$ | async;
              track treatmentCategory.ref.path
            ) {
              <mat-option [value]="treatmentCategory.ref">
                {{ treatmentCategory.name }}
                <div
                  class="inline-block h-3 w-3 rounded-full"
                  [style.backgroundColor]="treatmentCategory.colour.value"
                ></div>
              </mat-option>
            }
          </mat-select>
          <button
            type="button"
            matIconSuffix
            mat-icon-button
            [disabled]="treatmentCategoryBloc.resetDisabled$ | async"
            (click)="treatmentCategoryBloc.clear($event)"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <mat-form-field>
        <mat-label>Amount</mat-label>
        <span matTextPrefix>$&nbsp;</span>
        <input
          matInput
          type="number"
          min="0"
          step="0.01"
          formControlName="amount"
        />
      </mat-form-field>

      <mat-form-field>
        <mat-label>Payment Method</mat-label>
        <mat-select formControlName="method">
          <ng-container
            *ngFor="let group of optionGroups$ | async; trackBy: trackByGroup"
          >
            <ng-template #rootOptions>
              <mat-option
                *ngFor="let option of group.options; trackBy: trackByOption"
                [value]="option"
              >
                {{ option.label }}
              </mat-option>
            </ng-template>

            <mat-optgroup
              *ngIf="group.label; else rootOptions"
              [label]="group.label"
            >
              <mat-option
                *ngFor="let option of group.options; trackBy: trackByOption"
                [value]="option"
              >
                {{ option.label }}
              </mat-option>
            </mat-optgroup>
          </ng-container>
        </mat-select>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <pt-buttons-container padding="none">
      <button mat-stroked-button mat-dialog-close>Cancel</button>
      <button mat-flat-button color="primary" [disabled]="isDisabled$ | async">
        Create
      </button>
    </pt-buttons-container>
  </mat-dialog-actions>
</form>
